import { render, staticRenderFns } from "./TabNav.vue?vue&type=template&id=69a44aa6&scoped=true"
import script from "./TabNav.vue?vue&type=script&lang=ts"
export * from "./TabNav.vue?vue&type=script&lang=ts"
import style0 from "./TabNav.vue?vue&type=style&index=0&id=69a44aa6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a44aa6",
  null
  
)

export default component.exports